import {
  TimeInput as NextUITimeInput,
  TimeInputProps as NextUITimeInputProps,
} from "@heroui/react";
import { Time } from "@internationalized/date";
import { getDateInputClassNames } from "ds/utils/styles";
import { toHeroUITimeProp } from "../../utils/date";

type Color = Extract<NextUITimeInputProps["color"], "default">;
type LabelPlacement = Extract<
  NextUITimeInputProps["labelPlacement"],
  "outside"
>;
type Variant = Extract<NextUITimeInputProps["variant"], "bordered">;

export type TimeInputProps = Omit<
  NextUITimeInputProps,
  "color" | "labelPlacement" | "variant" | "value" | "minValue" | "maxValue"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  maxValue?: Date;
  minValue?: Date;
  value?: Date | Time | null;
  variant?: Variant;
};

export function TimeInput(props: TimeInputProps) {
  const { maxValue, minValue, value, ...rest } = props;

  return (
    <NextUITimeInput
      {...rest}
      classNames={getDateInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement="outside"
      maxValue={toHeroUITimeProp<NextUITimeInputProps["maxValue"]>(maxValue)}
      minValue={toHeroUITimeProp<NextUITimeInputProps["minValue"]>(minValue)}
      value={toHeroUITimeProp<NextUITimeInputProps["value"]>(value)}
      variant="bordered"
    />
  );
}

TimeInput.displayName = "RecareUI.TimeInput";
